module.exports = __webpack_public_path__ + "static/CommSec-7695699fc36c6a797bb989ea64297089.png";